import { Box } from "@jewlr/storybook/core"
import PropTypes from "prop-types"
import { Helmet } from "react-helmet-async"
import styled from "styled-components"

const Container = styled(Box).attrs((props) => ({
  contain: props.contain,
  mb: 5,
  px: 2,
}))``

const OrderRouteWrapper = ({ children, contain, description, title }) => (
  <>
    <Helmet>
      <title>{title}</title>
      {description && <meta content={description} name="description" />}
      {description && <meta content={description} property="og:description" />}
    </Helmet>
    <Container contain={contain}>{children}</Container>
  </>
)

OrderRouteWrapper.propTypes = {
  children: PropTypes.node,
  contain: PropTypes.bool,
  description: PropTypes.string,
  title: PropTypes.string,
}

export default OrderRouteWrapper
